// extracted by mini-css-extract-plugin
export default {"loaderInlineDimmer":"LoaderInline_loaderInlineDimmer__26mzL"};